export default "__VITE_ASSET__BIclpPdG__"